import FormControlFeedback from 'components/common/FormControlFeedback';
import TooltipCommon from 'components/common/TooltipCommon';
import TooltipCommonMobile from 'components/common/TooltipCommon/mobile';
import { OBJECT_DEFAULT } from 'constants';
import { useDetectDevice } from 'hooks/useDetectDevice';
import { isEmpty } from 'lodash';
import { useRef } from 'react';
import { Form } from 'react-bootstrap';
import styled from 'styled-components';
import { paragraph700Mixin, paragraphMixin } from 'styles';
import { stringUtils } from 'utils';
import useLang from '../useLang';

const useFormInput = (fieldConfig) => {
  const { t } = useLang();
  const { isDesktop } = useDetectDevice();

  const inputRef = useRef();

  const { name, label, tooltip, isRequired } = fieldConfig || {};

  // FUNCTIONS
  const resetFormInput = ({
    information = {},
    setInformation = () => {},
    validation = {},
    setValidation = () => {},
  }) => {
    const newInfomation = {
      ...information,
      [name]: '',
    };
    setInformation(newInfomation);

    const newValidation = {
      ...validation,
      [name]: '',
    };
    setValidation(newValidation);
  };
  const setInformationFormInput = ({
    value = '',
    information = {},
    setInformation = () => {},
  }) => {
    const newInformation = {
      ...information,
      [name]: value,
    };
    setInformation(newInformation);

    return newInformation;
  };
  const setValidationFormInput = ({
    validation = {},
    setValidation = () => {},
    isReset = false,
    value = '',
    checkFormInputValidation = () => {},
  }) => {
    let newValidation = { ...validation };
    if (isReset) {
      newValidation = {
        ...newValidation,
        [name]: '',
      };
    } else if (value) {
      newValidation = {
        ...newValidation,
        [name]: value,
      };
    } else {
      newValidation = checkFormInputValidation(
        value,
        fieldConfig,
        newValidation
      );
    }
    setValidation(newValidation);

    return newValidation;
  };

  // UTILS
  const handleFormLabelOnClick = (e) => {
    e?.preventDefault();
    inputRef.current?.focus();
  };
  const getValueTrim = (value = '', isUpperCase = false) => {
    if (isUpperCase) return !isEmpty(value) ? value.trim().toUpperCase() : '';
    return !isEmpty(value) ? value.trim() : '';
  };
  const getValueTrimAll = (value = '', isUpperCase = false, regex = '') => {
    if (isUpperCase)
      return !isEmpty(value)
        ? stringUtils.trimAll(value, regex).toUpperCase()
        : '';
    return !isEmpty(value) ? stringUtils.trimAll(value, regex) : '';
  };

  // COMPONENTS
  const renderTooltip = () => {
    if (!tooltip) return;
    if (!isDesktop)
      return (
        <TooltipCommonMobile text={t(tooltip)} name={name} label={t(label)} />
      );
    return <TooltipCommon text={t(tooltip)} />;
  };
  const FormLabelComponent = ({
    value = '',
    isConfigRequired = false,
    isDisplayContents = false,
    styles = {},
  }) => (
    <>
      <FormLabel
        onClick={handleFormLabelOnClick}
        $isDisplayContents={tooltip || isDisplayContents}
        style={styles}
      >
        {value || t(label)}
        {(isConfigRequired || isRequired) && <span>*</span>}
      </FormLabel>
      {renderTooltip()}
    </>
  );
  const FormControlFeedbackComponent = ({
    value = '',
    validationStyles = OBJECT_DEFAULT,
  }) => {
    if (!value) return null;
    return (
      <FormControlFeedback value={value} styles={validationStyles || {}} />
    );
  };

  return {
    inputRef,
    // FUNCTIONS
    resetFormInput,
    setInformationFormInput,
    setValidationFormInput,
    // UTILS
    getValueTrim,
    getValueTrimAll,
    // COMPONENTS
    FormLabel: FormLabelComponent,
    FormControlFeedback: FormControlFeedbackComponent,
  };
};

const FormLabel = styled(Form.Label)`
  ${paragraphMixin};
  ${paragraph700Mixin};
  text-align: left;
  display: block;
  width: fit-content;
  display: ${(props) => (props.$isDisplayContents ? 'contents' : 'inherit')};

  & span {
    color: var(--c-required);
  }
`;

export default useFormInput;
